import { CultureInfo } from '../culture-info.model';
import { CultureInfoLn } from './ln';

/**
 * @ignore
 */
export const CultureInfoLnCF: CultureInfo = {
  name: 'ln-CF',
  displayName: 'lingála (Repibiki ya Afríka ya Káti)',
  iso3LanguageCode: 'lin',
  iso2LanguageCode: 'ln',
  ietfLanguageTag: 'ln-CF',
  parent: CultureInfoLn
};
